import type React from 'react';

import { BannerStateContainer } from '@confluence/banners';

const OBJECT_SIDEBAR_PANEL_WIDTH = 400;
const VERSION_HISTORY_SIDE_PANEL_WIDTH = 320;

const calculateIframeWidth = (isSidebarPanelOpen: boolean, isVersionHistoryOpen: boolean) => {
	if (isSidebarPanelOpen) {
		return `calc(100% - ${OBJECT_SIDEBAR_PANEL_WIDTH}px)`;
	}
	if (isVersionHistoryOpen) {
		return `calc(100% - ${VERSION_HISTORY_SIDE_PANEL_WIDTH}px)`;
	}
	return '100%';
};

export const databaseHeightContainer = [BannerStateContainer];
export const databaseShellStyle = (
	topNavAndBannerHeight: number,
	isVersionHistoryOpen: boolean = false,
	isObjectSidebarShown: boolean = false,
): React.CSSProperties => ({
	width: calculateIframeWidth(isObjectSidebarShown, isVersionHistoryOpen),
	height: topNavAndBannerHeight > 0 ? `calc(100vh - ${topNavAndBannerHeight}px)` : '100vh',
	display: 'block',
	border: '0px',
	...(isVersionHistoryOpen || isObjectSidebarShown
		? { transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s' }
		: {}),
});
